// extracted by mini-css-extract-plugin
module.exports = {"container":"Lottery_container__38MFs","stats":"Lottery_stats__3Q_0F"};